"use client";

import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {useTranslation} from "@/shared/i18n";
import type {TranslationKey} from "@/shared/i18n/types";
import {assetPath} from "@/shared/utils/asset-path";
import {TRIP_TABS, type TripTab} from "@/shared/utils/routing";

import "./styles/trip-overview-quick-links.scss";

export interface TripOverviewQuickLinksProps {
    onSelectTab: (tab: TripTab) => void;
}

const ITEMS: Array<{tab: TripTab; icon: string; titleKey: TranslationKey; subtitleKey: TranslationKey}> = [
    {tab: TRIP_TABS.gettingThere, icon: "/images/icons/location.svg", titleKey: "trip.navGettingThere", subtitleKey: "trip.gettingThereSubtitle"},
    {tab: TRIP_TABS.amenities, icon: "/images/icons/house.svg", titleKey: "trip.navAmenities", subtitleKey: "trip.amenitiesSubtitle"},
    {tab: TRIP_TABS.terms, icon: "/images/icons/list.svg", titleKey: "trip.navRentalTerms", subtitleKey: "trip.rentalTermsSubtitle"},
    {tab: TRIP_TABS.pricing, icon: "/images/icons/dollar.svg", titleKey: "trip.navPricing", subtitleKey: "trip.pricingSubtitle"},
];

export interface TripOverviewQuickLinksProps {
    onSelectTab: (tab: TripTab) => void;
    tabs?: Array<TripTab>;
}

export function TripOverviewQuickLinks({onSelectTab, tabs}: TripOverviewQuickLinksProps): JSX.Element {
    const {t} = useTranslation();

    const items = tabs ? ITEMS.filter((item) => tabs.includes(item.tab)) : ITEMS;

    return (
        <div className="trip-overview-quick-links">
            {items.map((item) => (
                <button key={item.tab} type="button" className="trip-overview-quick-links__card" onClick={() => onSelectTab(item.tab)}>
                    <SmartImage src={assetPath(item.icon)} alt="" width={20} height={20} />
                    <span className="trip-overview-quick-links__title">{t(item.titleKey)}</span>
                    <span className="trip-overview-quick-links__subtitle">{t(item.subtitleKey)}</span>
                </button>
            ))}
        </div>
    );
}
